import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import HVERequestForm from './HVERequestForm';
import './HVERequestFormModal.scss';

export default class HVERequestFormModal extends Component {
    static get PropTypes() {
        return {
            address: PropTypes.string
        };
    }

    render() {
        return (
            <div className="modal nu-modal hve-request-form-modal fade in">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <HVERequestForm {...this.props}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
